/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  Lusd3CrvMagician,
  Lusd3CrvMagicianInterface,
} from "../Lusd3CrvMagician";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_lusd3CrvPool",
        type: "address",
      },
      {
        internalType: "address",
        name: "_crv3Pool",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tricrypto2",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lusd",
        type: "address",
      },
      {
        internalType: "address",
        name: "_usdt",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "address",
        name: "_crv3Lp",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmptyAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "Unsupported",
    type: "error",
  },
  {
    inputs: [],
    name: "CRV3LP_INDEX_LUSD3CRV_POOL",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "CRV3_POOL",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "CRV_3_LP",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LUSD",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LUSD_3CRV_POOL",
    outputs: [
      {
        internalType: "contract ICurvePoolLike128WithReturn",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LUSD_INDEX_LUSD3CRV_POOL",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRICTYPTO_2_POOL",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UNKNOWN_AMOUNT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDT",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type Lusd3CrvMagicianConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: Lusd3CrvMagicianConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Lusd3CrvMagician__factory extends ContractFactory {
  constructor(...args: Lusd3CrvMagicianConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Lusd3CrvMagician";
  }

  deploy(
    _lusd3CrvPool: string,
    _crv3Pool: string,
    _tricrypto2: string,
    _lusd: string,
    _usdt: string,
    _weth: string,
    _crv3Lp: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Lusd3CrvMagician> {
    return super.deploy(
      _lusd3CrvPool,
      _crv3Pool,
      _tricrypto2,
      _lusd,
      _usdt,
      _weth,
      _crv3Lp,
      overrides || {}
    ) as Promise<Lusd3CrvMagician>;
  }
  getDeployTransaction(
    _lusd3CrvPool: string,
    _crv3Pool: string,
    _tricrypto2: string,
    _lusd: string,
    _usdt: string,
    _weth: string,
    _crv3Lp: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _lusd3CrvPool,
      _crv3Pool,
      _tricrypto2,
      _lusd,
      _usdt,
      _weth,
      _crv3Lp,
      overrides || {}
    );
  }
  attach(address: string): Lusd3CrvMagician {
    return super.attach(address) as Lusd3CrvMagician;
  }
  connect(signer: Signer): Lusd3CrvMagician__factory {
    return super.connect(signer) as Lusd3CrvMagician__factory;
  }
  static readonly contractName: "Lusd3CrvMagician";
  public readonly contractName: "Lusd3CrvMagician";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): Lusd3CrvMagicianInterface {
    return new utils.Interface(_abi) as Lusd3CrvMagicianInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Lusd3CrvMagician {
    return new Contract(address, _abi, signerOrProvider) as Lusd3CrvMagician;
  }
}
